import React, { useState } from "react";
import "./Services.css";
const Services = () => {
    const serviceCategories = [
      {
        title: "SAP Solutions",
        sections: [
          { name: "SAP Implementation", description: "Deploy SAP solutions with end-to-end project management, ensuring smooth transitions and business continuity." },
          { name: "SAP S/4HANA Migration", description: "Migrate from legacy SAP systems to S/4HANA for enhanced efficiency, security, and cloud compatibility." },
          { name: "SAP Security Services", description: "Comprehensive security strategies to protect and optimize your SAP landscape, ensuring compliance and performance." },
          { name: "SAP Managed Services", description: "Reliable maintenance, monitoring, and support to maximize SAP system performance and uptime." }
        ]
      },
      {
        title: "Data Integration & Analytics",
        sections: [
          { name: "Enterprise Data Integration", description: "Seamlessly connect disparate data sources for real-time insights and improved decision-making." },
          { name: "Advanced Analytics & BI", description: "Leverage predictive analytics, dashboards, and AI-powered insights to drive data-driven strategies." },
          { name: "Cloud Data Solutions", description: "Optimize storage, security, and performance with scalable cloud data solutions tailored to your business needs." }
        ]
      },
      {
        title: "AI & Automation",
        sections: [
          { name: "Intelligent Process Automation", description: "Automate repetitive business tasks using AI-powered bots and machine learning models." },
          { name: "AI-Driven Decision Support", description: "Enhance strategic planning with AI-driven simulations and predictive insights tailored to your industry." },
          { name: "Conversational AI & Chatbots", description: "Improve customer engagement and support efficiency with AI-powered virtual assistants and chatbots." }
        ]
      },
      {
        title: "Custom Enterprise Solutions",
        sections: [
          { name: "Custom ERP Development", description: "Design and implement ERP solutions tailored to your industry’s specific needs and workflows." },
          { name: "Workflow Automation", description: "Optimize and streamline business processes with intelligent automation tools and enterprise integrations." },
          { name: "Industry-Specific Solutions", description: "Develop tailored applications for finance, manufacturing, healthcare, and other industries." }
        ]
      }
    ];
  
    return (
      <div className="services-page">
        <section className="hero-section">
          <h1 className="hero-title">Innovating with SAP, Data & AI</h1>
          <p className="hero-subtitle">Customized solutions to drive efficiency, intelligence, and growth.</p>
        </section>
  
        <section className="service-categories">
          {serviceCategories.map((category, index) => (
            <div key={index} className="service-category expanded">
              <h2 className="category-title">{category.title}</h2>
              <div className="category-sections">
                {category.sections.map((section, idx) => (
                  <div key={idx} className="service-card">
                    <h3 className="service-title">{section.name}</h3>
                    <p className="service-description">{section.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>
      </div>
    );
  };
  
  export default Services;
  
  